import { memo, createElement } from '@max/max';
import Text from '@hfe/max-text';
import LImage from '@max/leez-image';
import View from '@hfe/max-view';
import Icon from '@max/leez-icon';
import { rpx2px } from '@hfe/max-universal-unit-tool';
import './index.scss';
const CityCardItem = (props) => {
    const { card, width = 528, height = 396, className, isNoMask = false } = props;
    const currentStyle = {
        width: `${width}rpx`,
        height: `${height}rpx`
    };
    if (!card)
        return <View className={className} style={Object.assign(Object.assign({}, currentStyle), { borderRadius: '28rpx', overflow: 'hidden' })}>

    </View>;
    let showTags = [];
    if (card.cityTag) {
        showTags = card.cityTag.split(/[,，]/).map(item => item.trim());
    }
    return <View key={card.cityId} className={className} style={Object.assign(Object.assign({}, currentStyle), { borderRadius: '28rpx', overflow: 'hidden' })}>
      <LImage source={{
        uri: card.imgUrl
    }} style={Object.assign({}, currentStyle)} width={rpx2px(width)} height={rpx2px(height)} borderRadius={0} resizeMode='cover'/>
      
        <View className="city-card-item__main">
          <LImage className="city-card-item__main-bg" source={{
        uri: 'https://p0.meituan.net/ingee/b9291f1057d18592d26320e3c777d0d92655.png'
    }} style={{
        overflow: 'visible'
    }} width={rpx2px(width)} height={rpx2px(167)}>
            <View className="city-card-item__city-title-wrap">
              <Text className="city-card-item__city-title-text">{card.cityName}</Text>
              <Text className="city-card-item__city-title-text"> | </Text>
              <Text className="city-card-item__city-title-text">{card.cityTitle}</Text>
            </View>
            <View className="city-card-item__city-tags">
              <View x-if={card.driveTime} className="city-card-item__city-tag-item" style={{
        backgroundColor: '#FFE74D'
    }}>
                <Icon name='dachemian' 
    // type='extraLarge1'
    size={10} color="#111" style={{
        marginRight: '4rpx',
        marginTop: '2rpx'
    }}/>
                <Text className="city-card-item__city-tag-text" style={{
        color: '#111'
    }}>自驾{card.driveTime}小时</Text>
              </View>
              {showTags.map(tag => {
        return <View className="city-card-item__city-tag-item">
                    <Text className="city-card-item__city-tag-text">{tag}</Text>
                  </View>;
    })}
            </View>
            <View className="city-card-item__city-desc">
              <Text className="city-card-item__city-text">{card.cityDescription}</Text>
            </View>
          </LImage>
        </View>
      <View x-if={card.isWishCity && !card.display && !isNoMask} className="city-card-item__mask"/>
      
      <View x-if={card.isWishCity} className="wish-city-flag">
        <LImage source={{
        uri: !card.display ? "https://p0.meituan.net/ingee/cad36f7a9fbf658b7b53071af5aa31d15268.png" : "https://p0.meituan.net/ingee/e5de65eca3b54e37d25ec1d22bd1a56e6308.png"
    }} style={{
        width: '278rpx',
        height: '63rpx'
    }} borderRadius={0}/>
      </View>
    </View>;
};
export default memo(CityCardItem);
